import { createSelector } from '@reduxjs/toolkit';
import { selectJsonQuery } from './selectJsonQuery';
import { getTermValue } from '../../../packages/JsonQuery';

export const selectHasPhone = createSelector(selectJsonQuery, jsonQuery => getTermValue('phone')(jsonQuery));
